export const CONNECTOR_LINE_COLOR = 'grey.300' as const;

/** Uniform light-gray background for all collapsible section labels. */
export const LABEL_BG = 'grey.100' as const;

export const sectionLabelSx = {
  mb: 1,
  color: 'text.primary',
  fontWeight: 600,
} as const;

export const HEADER_ICON_SX = { fontSize: 16, color: 'text.secondary', display: 'block' } as const;

/**
 * Left-border visual hierarchy — opacity decreases with nesting depth.
 * Used by CollapsibleLogicSection and the single-DomainFilter wrapper in AVLogicCard.
 */
const LEFT_BORDER_ALPHA = [0.45, 0.3, 0.18, 0.1] as const;

export const LEFT_BORDER_WIDTH = [3, 3, 2, 2] as const;

const pick = <T>(arr: readonly T[], depth: number): T => arr[Math.min(depth, arr.length - 1)];

export function getLeftBorderColor(depth: number): string {
  return `rgba(0, 0, 0, ${pick(LEFT_BORDER_ALPHA, depth)})`;
}

export function getLeftBorderWidth(depth: number): number {
  return pick(LEFT_BORDER_WIDTH, depth);
}
